import { RULES_VERSION, inferResponseBlocks } from './inferResponseBlocks'

/**
 * Memoizes inference on `(text, rulesVersion)` — cross-cutting requirement C2.
 *
 * Without it `inferResponseBlocks` runs on every render of every message in the
 * thread, including once per streamed chunk, which is O(n²) over a turn.
 *
 * A plain Map would grow for the life of the tab, and streaming produces one
 * distinct prefix string per chunk — thousands of dead keys per conversation.
 * So the cache is bounded and evicts oldest-first.
 */
const MAX_ENTRIES = 64
const cache = new Map()

export function inferResponseBlocksMemo(text) {
  const key = `${RULES_VERSION}:${text}`
  const hit = cache.get(key)
  if (hit) {
    // Refresh recency so the entries a visible thread keeps asking for survive
    // a burst of streaming prefixes.
    cache.delete(key)
    cache.set(key, hit)
    return hit
  }

  const blocks = inferResponseBlocks(text)
  cache.set(key, blocks)
  if (cache.size > MAX_ENTRIES) cache.delete(cache.keys().next().value)
  return blocks
}

/** Test seam. */
export function clearInferenceCache() {
  cache.clear()
}
